import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AdminViewModel } from 'src/app/models/AdminViewModel';
import { PlanVM } from 'src/app/models/PlansVM';

@Injectable({
    providedIn: 'root'
})
export class VesselService {
    public baseurl = environment.apiUrl;
    private vesselApi = "api/Vessel/";
    constructor(private http: HttpClient) { }

    GetVessselsList(data) {
        const url = this.baseurl + this.vesselApi + '?' + this.GetVesselListParameters(data);
        return this.http.get(url, data);
    }

    GetVesselsdetailsByVesselsId(id) {
        const url = this.baseurl + this.vesselApi + id;
        return this.http.get(url);
    }

    UpdateVessel(data) {
        const url = this.baseurl + this.vesselApi;
        return this.http.put(url, data);
    }

    AddVessel(data) {
        const url = this.baseurl + this.vesselApi;
        return this.http.post(url, data);
    }

    GetVesselsdetailsByShippinglineId(id: number,fromDate:string) {
        const url = this.baseurl + this.vesselApi+ "shippingline?id="+ id+ "&fromDate="+ fromDate;
        return this.http.get(url);
    }

    private GetVesselListParameters(data: AdminViewModel) {
        let url = "";
        if (data.pageNo) {
            url = url + `pageNo=${data.pageNo}`
        }
        if (data.pageSize) {
            url = url + `&pageSize=${data.pageSize}`
        }
        if (data.searchText) {
            url = url + `&searchText=${data.searchText}`
        }
        if (data.sort) {
            url = url + `&sort=${data.sort}`
        }
        if (data.columnName) {
            url = url + `&columnName=${data.columnName}`
        }
        if (data.regionId) {
            url = url + `&regionId=${data.regionId}`
        }
        if (data.countryId) {
            url = url + `&countryId=${data.countryId}`
        }
        if (data.shippinglineId) {
            url = url + `&shippinglineId=${data.shippinglineId}`
        }
        return url;
    }
}
